import React, {createContext} from 'react';
const SlideshowContext = createContext(null);
export {SlideshowContext};